import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react'
import {store, persistor} from './store/store'

import {BrowserRouter as Router} from 'react-router-dom';

import {loadSettings} from './settings';

const root = ReactDOM.createRoot(document.getElementById('root'));
const showSettingsError = error => root.render(
  <main role="alert" style={{fontFamily: 'sans-serif', margin: '2rem'}}>
    <h1>Anwendung konnte nicht gestartet werden</h1>
    <p>Die Runtime-Konfiguration unter <code>assets/settings.json</code> ist nicht verfügbar oder ungültig.</p>
    <p>{error.message}</p>
  </main>
)

const bootstrap = async () => {
  try {
    await loadSettings()
    const {default: App} = await import('./App')
    root.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <App/>
          </Router>
        </PersistGate>
      </Provider>
    )
  } catch (error) {
    showSettingsError(error)
  }
}

bootstrap()
